#@import Booking.Presenters.OptionPicker
#@import Booking.Views.Picker
#@import Booking.Views.Options
#@export Booking.Views.OptionPicker

class Booking.Views.OptionPicker extends Booking.Views.Picker

  presenter: Booking.Presenters.OptionPicker

  contentView: Booking.Views.Options

  templateName: 'optionpicker'

  styleClassName: 'options'

  attributes: ->
    'data-bhw': "#{Booking.bhw}DealOptions"

  setSelection: (selection) ->
    @model.setSelectedOption(selection)

  selected: ->
    @model.getSelectedOption()
